import Pusher from "pusher-js"
import {config} from "../../config/config"

export const pusher = new Pusher(config.pusher.key, {
    cluster: config.pusher.cluster,
    forceTLS: true,
    pongTimeout: 10
})
